// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dCoordinates from "../Data.Coordinates/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dGeocoding$dTypes$dStreetAddress from "../Restaumatic.Geocoding.Types.StreetAddress/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unscramble from "../Unscramble/index.js";
const streetAddressIsSymbol = {reflectSymbol: () => "streetAddress"};
const ReverseGeocodeResponseIsSymbol = {reflectSymbol: () => "ReverseGeocodeResponse"};
const coordinatesIsSymbol = {reflectSymbol: () => "coordinates"};
const GeocodeResponseIsSymbol = {reflectSymbol: () => "GeocodeResponse"};
const ReverseGeocodeResponse = x => x;
const GeocodeResponse = x => x;
const newtypeReverseGeocodeResp = {Coercible0: () => {}};
const newtypeGeocodeResponse_ = {Coercible0: () => {}};
const hasFieldReverseGeocodeRes = dictHasField => dictHasField;
const hasFieldGeocodeResponse = dictHasField => dictHasField;
const eqReverseGeocodeResponse = {
  eq: x => y => {
    if (x.streetAddress.tag === "Nothing") { return y.streetAddress.tag === "Nothing"; }
    if (x.streetAddress.tag === "Just") {
      if (y.streetAddress.tag === "Just") {
        return x.streetAddress._1.city === y.streetAddress._1.city && x.streetAddress._1.street === y.streetAddress._1.street && x.streetAddress._1.streetNumber === y.streetAddress._1.streetNumber;
      }
      return false;
    }
    return false;
  }
};
const eqGeocodeResponse = {
  eq: x => y => {
    if (x.coordinates.tag === "Nothing") { return y.coordinates.tag === "Nothing"; }
    if (x.coordinates.tag === "Just") {
      if (y.coordinates.tag === "Just") { return x.coordinates._1.lat === y.coordinates._1.lat && x.coordinates._1.lon === y.coordinates._1.lon; }
      return false;
    }
    return false;
  }
};
const genericReverseGeocodeResponse = {to: x => x, from: x => x};
const showReverseGeocodeResponse = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          if (v.streetAddress.tag === "Just") {
            return "{ streetAddress: (Just " + Restaumatic$dGeocoding$dTypes$dStreetAddress.showStreetAddress.show(v.streetAddress._1) + ") }";
          }
          if (v.streetAddress.tag === "Nothing") { return "{ streetAddress: Nothing }"; }
          $runtime.fail();
        })()
      ]
    })(ReverseGeocodeResponseIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeReverseGeocodeResponse = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(streetAddressIsSymbol)(Unscramble.decodeMaybe(Restaumatic$dGeocoding$dTypes$dStreetAddress.unscrambleDecodeStreetAddress))(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericGeocodeResponse = {to: x => x, from: x => x};
const showGeocodeResponse = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          if (v.coordinates.tag === "Just") { return "{ coordinates: (Just " + Data$dCoordinates.showCoordinates.show(v.coordinates._1) + ") }"; }
          if (v.coordinates.tag === "Nothing") { return "{ coordinates: Nothing }"; }
          $runtime.fail();
        })()
      ]
    })(GeocodeResponseIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeGeocodeResponse = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(coordinatesIsSymbol)(Unscramble.decodeMaybe(Data$dCoordinates.unscrambleDecodeCoordinates))(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeReverseGeocodeResponse = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericReverseGeocodeResponse)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(ReverseGeocodeResponseIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(streetAddressIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dGeocoding$dTypes$dStreetAddress.encodeStreetAddress.encode(v2._1); }
        $runtime.fail();
      }
    });
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeGeocodeResponse = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericGeocodeResponse)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(GeocodeResponseIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(coordinatesIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Data$dCoordinates.encodeCoordinates.encode(v2._1); }
        $runtime.fail();
      }
    });
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeReverseGeocodeResponse = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericReverseGeocodeResponse)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ReverseGeocodeResponseIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(streetAddressIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dGeocoding$dTypes$dStreetAddress.decodeStreetAddress.decode)
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeGeocodeResponse = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericGeocodeResponse)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(GeocodeResponseIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(coordinatesIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Data$dCoordinates.decodeCoordinates.decode)
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  GeocodeResponse,
  GeocodeResponseIsSymbol,
  ReverseGeocodeResponse,
  ReverseGeocodeResponseIsSymbol,
  coordinatesIsSymbol,
  decodeGeocodeResponse,
  decodeReverseGeocodeResponse,
  encodeGeocodeResponse,
  encodeReverseGeocodeResponse,
  eqGeocodeResponse,
  eqReverseGeocodeResponse,
  genericGeocodeResponse,
  genericReverseGeocodeResponse,
  hasFieldGeocodeResponse,
  hasFieldReverseGeocodeRes,
  newtypeGeocodeResponse_,
  newtypeReverseGeocodeResp,
  showGeocodeResponse,
  showReverseGeocodeResponse,
  streetAddressIsSymbol,
  unscrambleDecodeGeocodeResponse,
  unscrambleDecodeReverseGeocodeResponse
};
